import UseTriggerContext from 'modules/reports/hooks/trigger/useTrigger.context'
import {useContext} from 'react'

export default function useTriggerChild() {
  return useContext(UseTriggerContext)
}
